// Kinds/Presets — Set14 P5 §4.8: the 15 preset kinds (derived from the ez-tree root
// `Kind_EzTree`). GENERATED by `Scripts/EzTree/PresetConverter.js` (npm start client.
// eztree.convertPresets; via `EzTreeParams.treeOptionsToFlat`, so a key rename can't desync
// them) — but NOT read-only: hand tweaks are expected (rerun the converter only to see the
// drift vs. upstream ez-tree). This file catalogues them in a stable order for the registry.
//
// The `Trellis` preset is deliberately NOT shipped (§4.3 d — it is a guided-growth kind for vines
// on structures, not a scenery tree).
import type {SceneryKindDef} from "../../@SceneryTypes.js";
import {AshSmallKind} from "./Kind_EzTree_AshSmall.js";
import {AshMediumKind} from "./Kind_EzTree_AshMedium.js";
import {AshLargeKind} from "./Kind_EzTree_AshLarge.js";
import {AspenSmallKind} from "./Kind_EzTree_AspenSmall.js";
import {AspenMediumKind} from "./Kind_EzTree_AspenMedium.js";
import {AspenLargeKind} from "./Kind_EzTree_AspenLarge.js";
import {Bush1Kind} from "./Kind_EzTree_Bush1.js";
import {Bush2Kind} from "./Kind_EzTree_Bush2.js";
import {Bush3Kind} from "./Kind_EzTree_Bush3.js";
import {OakSmallKind} from "./Kind_EzTree_OakSmall.js";
import {OakMediumKind} from "./Kind_EzTree_OakMedium.js";
import {OakLargeKind} from "./Kind_EzTree_OakLarge.js";
import {PineSmallKind} from "./Kind_EzTree_PineSmall.js";
import {PineMediumKind} from "./Kind_EzTree_PineMedium.js";
import {PineLargeKind} from "./Kind_EzTree_PineLarge.js";

/** The 15 generated preset kinds, in authoring order. */
export const builtInEzTreePresetKinds: SceneryKindDef[] = [
	AshSmallKind, AshMediumKind, AshLargeKind,
	AspenSmallKind, AspenMediumKind, AspenLargeKind,
	Bush1Kind, Bush2Kind, Bush3Kind,
	OakSmallKind, OakMediumKind, OakLargeKind,
	PineSmallKind, PineMediumKind, PineLargeKind,
];
